import { WhatsAppIntegration } from '@/models/whatsAppIntegration'

export function hasActiveOfficialWhatsAppTransport(
  integration?: WhatsAppIntegration | null
) {
  return Boolean(
    integration?.transports?.some(
      (transport) =>
        transport.isActive &&
        transport.type === 'official' &&
        transport.provider === 'coex-official'
    )
  )
}

export function usesOfficialDirectTransport(
  integration?: WhatsAppIntegration | null
) {
  return (
    hasActiveOfficialWhatsAppTransport(integration) &&
    integration?.directTransport === 'official'
  )
}
